module.exports = __webpack_public_path__ + "static/media/040-guatemala.ff991a33.svg";